import PropTypes from "prop-types";
import MoreStories from "../MoreStories/component";
import { NUM_SWIMLANE_STORIES } from "./constants";
import classNames from "classnames";
import { DISPLAY_TYPES } from "../ContentList/constants";

/**
 * The Swimlane component.
 *
 * This component renders a number of stories from the given section and can be embedded onto any Landing page. E.g. on the Homepage it will render News
 *
 */
function Swimlane({
    useGrid = false,
    section = "",
    headline = "",
    itemCount = NUM_SWIMLANE_STORIES,
    className,
    showMoreLink = true,
    customTitleBar = null,
    hasHeadlineLink = true,
    fetchSection = true,
    customHeadlineLink = "",
    customContentList = null,
    externalLink = false,
    contentListClasses,
    lineupSlug = "",
    cardClickHandler = () => {},
    extraContent = null,
    featureAttribution = null,
    id,
    children,
    displayPolicy,
}) {
    let newMoreStoriesHeadlineLink = "";
    if (hasHeadlineLink) {
        if (customHeadlineLink === "") {
            newMoreStoriesHeadlineLink = `/${section}`;
        } else {
            newMoreStoriesHeadlineLink = customHeadlineLink;
        }
    }

    const moreStoriesProps = {
        section,
        headline,
        headlineLink: newMoreStoriesHeadlineLink,
        externalLink,
        itemCount,
        showMoreLink,
        fetchSection,
        customTitleBar,
        customContentList,
        displayPolicy,
        cardClickHandler,
        contentListClasses: classNames(
            contentListClasses,
            "contentListSwimlane"
        ),
        lineupSlug,
        displayType: DISPLAY_TYPES.TYPE_LIST,
        useGrid,
    };

    const classes = classNames("swimlane", "sclt-swimlane", className);

    return (
        <div
            className={classes}
            id={`swimlane-${section || id}`}
            {...featureAttribution}
            data-testid="swimlane"
        >
            <MoreStories {...moreStoriesProps} />
            {extraContent ?? children}
        </div>
    );
}

Swimlane.propTypes = {
    id: PropTypes.string,
    section: PropTypes.string,
    headline: PropTypes.string,
    itemCount: PropTypes.number,
    className: PropTypes.string,
    showMoreLink: PropTypes.bool,
    customTitleBar: PropTypes.object,
    hasHeadlineLink: PropTypes.bool,
    fetchSection: PropTypes.bool,
    customHeadlineLink: PropTypes.string,
    customContentList: PropTypes.array,
    externalLink: PropTypes.bool,
    contentListClasses: PropTypes.string,
    lineupSlug: PropTypes.string,
    extraContent: PropTypes.element,
    featureAttribution: PropTypes.object,
};

export default Swimlane;
